module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block form form-horizontal"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2",
    class: {
      'has-danger': _vm.$v.model.peso.$error
    }
  }, [_c('label', [_vm._v("Peso (Kg)")]), _vm._v(" "), _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": "##.##"
    },
    model: {
      value: (_vm.model.peso),
      callback: function($$v) {
        _vm.$set(_vm.model, "peso", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "model.peso"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    class: {
      'has-danger': _vm.$v.model.data.$error
    }
  }, [_c('label', [_vm._v("Data*")]), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "config": _vm.config,
      "placeholder": "Selecione",
      "name": "date"
    },
    model: {
      value: (_vm.model.data),
      callback: function($$v) {
        _vm.$set(_vm.model, "data", $$v)
      },
      expression: "model.data"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-link",
    attrs: {
      "to": {
        name: 'list-weight-pet',
        params: {
          id: this.$route.params.id
        }
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Salvar")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fas fa-weight-hanging"
  }), _vm._v(" Peso\n                    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2549aacd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pets/weight/Form.vue
// module id = 840
// module chunks = 1